module.exports = "../../app/cells/pages/bifrost/study_guides/study_guide_item_cell.rb";